import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getAuthTokens } from '../utils/auth';
import api from './middleware';

export const jobApi = {
  // Start a test job

  // Start a test job with an optional fixture
  startTestJobWithFixture: async (testSuiteId, testCaseId, fixtureId = null) => {
    try {
      // Create request body, only include fixture_id if provided
      const requestBody = {
        test_case_id: testCaseId,
        test_suite_id: testSuiteId
      };
      
      // Only add fixture_id to the request if it's provided
      if (fixtureId) {
        requestBody.fixture_id = fixtureId;
      }

      const response = await api.post(
        '/api/run-single-test-case/job',
        requestBody
      );
      return response.data;
    } catch (error) {
      console.error('Job start error:', error);
      throw error;
    }
  },

  getJobStatus: async (jobId) => {
    try {
      const response = await api.get(`/api/job/${jobId}/testcases`);
      return response.data;
    } catch (error) {
      console.error('Job status error:', error);
      throw error;
    }
  },
  
  getJobs: async () => {
    try {
      const response = await api.get('/api/job/list-jobs');
      return response.data;
    } catch (error) {
      console.error('Error in getJobs:', error);
      throw error;
    }
  },
  
  startTestSuiteJob: async (suiteId) => {
    try {
      // First create a job for this test suite run
      const jobResponse = await api.post(
        '/api/job/run-test-suite', 
        { test_suite_id: suiteId }
      );

      const jobId = jobResponse.data.id;

      return {
        job_id: jobId
      };
    } catch (error) {
      console.error('Start test suite job error:', error);
      throw error;
    }
  },
  
  executeStep: async (stepData) => {
    try {
      const response = await api.post(
        '/api/job/execute-step',
        stepData
      );

      return response.data;
    } catch (error) {
      console.error('Execute step error:', error);
      throw error;
    }
  },
  
  executeJobTestCases: async (jobId, testCaseIds, heal = false) => {
    try {
      const response = await api.post(
        `/api/job/${jobId}/testcases`,
        {
          test_case_ids: testCaseIds
        },
        {
          params: {
            heal: heal
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Execute job test cases error:', error);
      throw error;
    }
  },
  
  healTestCases: async (jobId, testCaseIds) => {
    try {
      const response = await api.post(
        '/api/job/heal-testcases',
        {
          job_id: jobId,
          test_case_ids: testCaseIds
        }
      );
      return response.data;
    } catch (error) {
      console.error('Heal test cases error:', error);
      throw error;
    }
  },
  
  cancelJob: async (jobId) => {
    try {
      const response = await api.post(
        `/api/job/${jobId}/cancel`,
        {}
      );
      return response.data;
    } catch (error) {
      console.error('Cancel job error:', error);
      throw error;
    }
  }
};

export default jobApi; 